import React from 'react';
import useThemeStore from '../../store/ThemeStore';
export default function SosmedFooter(props) {
  const mode = useThemeStore((state) => state.mode);
  return (
    <>
      <a href={props.link} rel='noreferrer' target='_blank'>
        <div
          className={`${
            mode === 'light'
              ? 'bg-blue-500/30 hover:bg-blue-500/40'
              : 'bg-white/5 hover:bg-white/10'
          } backdrop-blur-sm rounded-md cursor-pointer shadow-md p-2 `}
        >
          <img
            src={mode === 'light' ? props.image2 : props.image1}
            alt="github"
            className='w-2'
          />
        </div>
      </a>
    </>
  );
}
